import * as z from "zod";
import { hsaPayoutSchema } from "./get-hsa-payouts";

/** One order's share of a payout; Gale has already merged split legs and
 * refunds into a single line. */
export const hsaPayoutBreakdownLineSchema = z.object({
  /** null = a constituent Gale could not match to an order — shown, never
   * dropped, so the lines still sum to the payout. */
  orderCode: z.string().nullable(),
  merchantReference: z.string().nullable(),
  customerName: z.string().nullable(),
  /** Net contribution to this payout; a refund-only line is negative. */
  amountCents: z.number().int(),
  /** `capture` | `refund` | … */
  types: z.array(z.string()),
  grossCents: z.number().int().nullable(),
  processingFeeCents: z.number().int().nullable(),
  lmnFeeCents: z.number().int().nullable(),
  totalFeesCents: z.number().int().nullable(),
});
export type HsaPayoutBreakdownLine = z.infer<
  typeof hsaPayoutBreakdownLineSchema
>;

/** One payout and what was in it. A payout the team doesn't own gets the same
 * generic not-found as the beta gate and an unknown id. */
export const getHsaPayout = {
  name: "getHsaPayout" as const,
  input: z.object({ payoutId: z.string().min(1) }),
  output: z.object({
    payout: hsaPayoutSchema,
    lines: z.array(hsaPayoutBreakdownLineSchema),
    transactionCount: z.number().int(),
  }),
};
